module.exports = __webpack_public_path__ + "static/media/logo-omz.34f92308.svg";